export const STRIPE_M2_READER_SESSION_V1_KEY = 'pointcraft.stripe-m2-reader-session-v1';
export const STRIPE_M2_READER_SESSION_V2_KEY = 'pointcraft.stripe-m2-reader-session-v2';

/** Non-secret SDK credential ownership metadata that must survive logout cleanup. */
export function isStripeM2ReaderSessionMetadataKey(type: string): boolean {
  return (
    type === STRIPE_M2_READER_SESSION_V1_KEY || type === STRIPE_M2_READER_SESSION_V2_KEY
  );
}
